/*
  Pagina /cart: re-renderiza as secoes do carrinho quando um item e adicionado
  por fora do formulario do carrinho (hoje, o "Levar junto!" do produto complementar).

  O product-form publica cartUpdate, mas so manda re-renderizar as secoes do
  carrinho lateral — o total e a barra de frete da pagina ficariam defasados.
  Aqui atualizamos as duas secoes inteiras (nao so .js-contents), porque a barra
  de frete gratis e o produto complementar vivem fora delas.
*/
(function () {
  var itemsEl = document.getElementById('main-cart-items');
  var footerEl = document.getElementById('main-cart-footer');
  if (!itemsEl || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  var sections = [itemsEl.dataset.id, footerEl && footerEl.dataset.id].filter(Boolean);
  if (!sections.length) return;

  function wrapperFor(id) {
    return document.getElementById('shopify-section-' + id);
  }

  // O product-form manda a gaveta abrir depois de adicionar. Na propria pagina
  // do carrinho isso cobre o conteudo sem necessidade, entao suprimimos a
  // abertura apenas quando o clique veio do produto complementar daqui.
  // O icone do carrinho no cabecalho continua abrindo a gaveta normalmente.
  var fromOrderBump = false;

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest && e.target.closest('.cart-page__order-bump .order-bump__btn')) {
        fromOrderBump = true;
      }
    },
    true
  );

  // cart-drawer.js carrega depois deste script, entao o elemento so ganha o
  // metodo open() mais tarde: esperamos a definicao antes de sobrescrever.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      var originalOpen = drawer.open.bind(drawer);
      drawer.open = function (trigger) {
        if (fromOrderBump) {
          fromOrderBump = false;
          return;
        }
        return originalOpen(trigger);
      };
    });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    // O cart.js ja cuida das mudancas feitas na propria lista de itens.
    if (event && event.source === 'cart-items') return;

    fetch(window.location.pathname + '?sections=' + sections.join(','))
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        sections.forEach(function (id) {
          var target = wrapperFor(id);
          if (!target || !data[id]) return;
          var fresh = new DOMParser()
            .parseFromString(data[id], 'text/html')
            .querySelector('#shopify-section-' + id);
          if (fresh) target.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function (err) {
        // Em caso de falha, recarrega: melhor um reload do que totais errados.
        console.error('cart-page-sync:', err);
        window.location.reload();
      });
  });
})();
